export const options_messageList_previewShow = "rWd";
export const options_messageList_previewHide = "sWd";
export const options_messageList_previewLabel = "tWd";
export default {options_messageList_previewShow,options_messageList_previewHide,options_messageList_previewLabel};